module.exports = __webpack_public_path__ + "static/Amira-112acad2ba6c8d497bf4aa149da47d4b.png";